import useSWR from 'swr';
import { useObservable } from 'rxjs-hooks';

import { servicesAPI } from '../services_api';
import { authAPI } from '../auth_api';

export function useCurrentUser() {
  const currentUser = useObservable(() => authAPI.currentUser);
  const userName = currentUser ? currentUser.user_name : '';

  const hasRole = role => currentUser && currentUser.roles.includes(role);

  const currentUserCan = permission => {
    if (permission === 'ImpersonateCustomer') return hasRole('Admin') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'ViewCustomer') return hasRole('Admin') || hasRole('CustomerSupport') || hasRole('ChargepointOperation') || hasRole('ChiefOperationsOfficer') || hasRole('ChargepointInstallation') || hasRole('Marketing') || hasRole('BusinessDevelopment'); // eslint-disable-line
    else if (permission === 'ManageCustomer') return hasRole('Admin') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'DeactivateCustomer') return hasRole('Admin') || hasRole('CustomerSupportSupervisor'); // eslint-disable-line
    else if (permission === 'ViewAsCustomer') return hasRole('Admin') || hasRole('Support') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'ManageHydra') return hasRole('Admin') || hasRole('DataAdministrator'); // eslint-disable-line
    else if (permission === 'EjectLance') return hasRole('Admin') || hasRole('Support') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'ManageLance') return hasRole('Admin') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'ManageCartridge') return hasRole('Admin') || hasRole('Support') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'ManageSumpPump') return hasRole('Admin') || hasRole('Support'); // eslint-disable-line
    else if (permission === 'ViewActiveSession') return hasRole('Admin') || hasRole('Support') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'ManageActiveSession') return hasRole('Admin') || hasRole('Support') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'ViewAllSessions') return hasRole('Admin') || hasRole('Support') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'ManageChargePoint') return hasRole('Admin') || hasRole('Support') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'MaintainChargePoint') return hasRole('Admin') || hasRole('Support') || hasRole('DataAdministrator'); // eslint-disable-line
    else if (permission === 'CapChargePoint') return hasRole('Admin') || hasRole('Support') || hasRole('CustomerSupport'); // eslint-disable-line
    else if (permission === 'MaintenanceMode') return hasRole('Admin') || hasRole('Support') || hasRole('DataAdministrator') || hasRole('CustomerSupportSupervisor'); // eslint-disable-line
    else if (permission === 'ViewAON') return hasRole('Admin') || hasRole('ChargepointInstallation') || hasRole('ChiefOperationsOfficer') || hasRole('ChargepointOperation') || hasRole('BusinessDevelopment'); // eslint-disable-line
    else if (permission === 'ManageAON') return hasRole('Admin') || hasRole('ChargepointInstallation'); // eslint-disable-line
    else if (permission === 'ViewPendingBills') return hasRole('Admin') || hasRole('DataAdministrator'); // eslint-disable-line
    else if (permission === 'DoAllTheThings') return hasRole('Admin'); // eslint-disable-line
    else if (permission === 'ManageGoogleCloud') return hasRole('Admin'); // eslint-disable-line
    else if (permission === 'ManageAxonHubInterface') return hasRole('Admin'); // eslint-disable-line
    else if (permission === 'BetaTest') return ['tom'].includes(userName); // eslint-disable-line
    else return false;
  };

  const { data: customer } = useSWR(
    hasRole('Customer') ? 'user/customer/id' : null,
    async () => {
      const res = await servicesAPI.CustomerServices(
        'getByUserId',
        currentUser.id
      );
      return res;
    }
  );

  return {
    currentUser,
    currentUserCan,
    currentUserIsCustomer: hasRole('Customer'),
    currentUserIsAdmin: hasRole('Admin'),
    currentUserIsTechnician: hasRole('Support'),
    currentUserIsCustomerSupport: hasRole('CustomerSupport'),
    currentUserIsExecutive: hasRole('Executive'),
    currentUserIsMonitor: hasRole('Monitor'),
    currentUserIsDebug: ['test_admin@trojanenergyltd.com', 'tom'].includes(
      userName
    ),
    customerId: customer ? customer.id : null,
    customerType: customer ? customer.customer_type : '',
    forgotPassword: authAPI.forgotPassword,
    resetForgottenPassword: authAPI.resetForgottenPassword,
    resetPassword: authAPI.resetPassword,
    impersonateCustomer: authAPI.impersonateCustomer
  };
}
